export const SEEKING_TYPES = Object.freeze({
  NONE: "none",
  BAND: "band",
  MEMBERS: "members",
});

export const SEEKING_LOOKUP_TYPES = Object.freeze([
  SEEKING_TYPES.BAND,
  SEEKING_TYPES.MEMBERS,
]);

export const isSeekingLookupType = (type) => SEEKING_LOOKUP_TYPES.includes(type);

export const normalizeSeekingPreferenceType = (value, fallback = SEEKING_TYPES.NONE) => {
  if (typeof value !== "string") {
    return fallback;
  }

  const normalized = value.trim().toLowerCase();
  if (normalized === SEEKING_TYPES.BAND) {
    return SEEKING_TYPES.BAND;
  }
  if (normalized === SEEKING_TYPES.MEMBERS || normalized === "member") {
    return SEEKING_TYPES.MEMBERS;
  }
  if (normalized === SEEKING_TYPES.NONE) {
    return SEEKING_TYPES.NONE;
  }

  return fallback;
};
